import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
//import sha256 from 'sha256';
import logo from '../../Assets/Images/ebs-logo-small.png';
import { AuthConsumer } from '../../Utils/AuthContext';
import { Configurations } from '../../Utils/Configurations';
import './Login.scss';

class Login extends Component {

    constructor(props) {
        super(props);
        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.isLogged = this.isLogged.bind(this);
        // this.carregaAtendimentos = this.carregaAtendimentos.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            user: '',
            pwd: '',
            isLoading: false
        }
    }

    isLogged(login) {
        const token = window.localStorage.getItem(this.Configurations.tokenKey);

        if (token) login(token);
    }

    handleInputChange(e) {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    handleOnInput(e) {
        if (e.target.value.length > 8) {
            e.target.value = e.target.value.slice(0, 8);
        }
    }

    handleLoginClick(e, login) {
        e.preventDefault();

        if (this.state.user === '' || this.state.pwd === '') {
            this.setState({ requiredFields: true });
            return;
        }

        this.setState({ isLoading: true });

        axios.post(this.Configurations.apiBasePath + '/auth', { user: this.state.user, password: this.state.pwd })
            .then(response => {
                login(response.data.data.token);
                this.props.history.push('/')
            })
            .catch(err => {
                this.setState({
                    errorMessage: 'Usuário e/ou Senha inválidos',
                    requiredFields: false,
                    isLoading: false
                });
            });

    }

    render() {
        return (
            <div className="container-fluid">
                <AuthConsumer>
                    {({ isAuth, login, logout }) => (
                        <div className="row">
                            {this.isLogged(login)}
                            <div className="col-10 offset-1 col-md-8 offset-md-2 col-lg-4 offset-lg-4 text-center">
                                <div className="card rounded my-5" >
                                    <div className="card-body" id="login">
                                        <div className="row no-gutters">
                                            <form className="w-100">
                                                <div className="col-12 mb-4">
                                                    <img src={logo} className="logo img-fluid" alt="Editora Brasil Seikyo" />
                                                </div>
                                                <div className="col-12 col-md-8 offset-md-2 mb-2">
                                                    <input type="text" name="user" onChange={this.handleInputChange} value={this.state.user} className="form-control text-center mb-1" placeholder="usuário" />

                                                </div>
                                                <div className="col-8 offset-2 col-md-6 offset-md-3">
                                                    <input type="password" maxLength="15" name="pwd" value={this.state.pwd} className="form-control text-center mb-1" id="senha" onChange={this.handleInputChange} placeholder="senha" data-toggle="popover" data-content="Disabled popover" data-placement="top"
                                                        title="mesma senha de acesso à extranet" />
                                                </div>
                                                <div className="col-12">
                                                    {(this.state.requiredFields) ? (<div className="text-danger bold">Para prosseguir informe usuário e senha</div>) : (<div></div>)}
                                                    {(this.state.errorMessage) ? (<div className="text-danger">{this.state.errorMessage}</div>) : (<div></div>)}
                                                    <button type="submit" className="btn btn-success mt-2" onClick={(e) => this.handleLoginClick(e, login)}>{this.state.isLoading ? 'aguarde...' : 'entrar'}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </AuthConsumer>
            </div>
        )
    }
}


export default withRouter(Login);